module.exports = __webpack_public_path__ + "static/media/nutritional-signals-thumbnail.c69af70e.jpg";